import { render, staticRenderFns } from "./LicitacaoRecursoContrarrazaoAnexo.vue?vue&type=template&id=ca0ce7e2"
import script from "./LicitacaoRecursoContrarrazaoAnexo.vue?vue&type=script&lang=js"
export * from "./LicitacaoRecursoContrarrazaoAnexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports